module.exports = __webpack_public_path__ + "static/img/thumbnail.95457c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191017/thumbnail.jpg
// module id = XbVC
// module chunks = 1